import {
  USER_KPI_ENTRY,
  FETCH_USER_DAILY_KPIS,
  WEEKLY_TOTALS,
  PERFORMANCE,
  GET_COMPETITIONS_ON_HOME,
  UPDATE_COMPETITION_ACTIVITY,
  UPDATE_SORT_ORDER,
  GET_USER_STREAK_DATA,
  UPDATE_USER_CELEBRATION_DATE,
  GET_USER_CELEBRATION_DATE,
  USER_CONFIGS,
  USER_NOTIFICATIONS,
  CLEAR_ALL_NOTIFICATIONS,
  SEEN_NOTIFICATION,
  CLEAR_NOTIFICATIONS_FOR_WINWIRE_MESSAGE,
} from "lib/constants";
import { getAPICall, postAPICall, putAPICall } from "../lib/callApi";

export const fetchDailyKpiInfo = async () => {
  const data = await getAPICall(FETCH_USER_DAILY_KPIS, true);
  return data;
};

export const fetchKpiEntry = async (payload) => {
  const data = await getAPICall(USER_KPI_ENTRY, true, payload);
  return data;
};
export const updateKpiEntry = async (payload) => {
  const data = await postAPICall(USER_KPI_ENTRY, true, payload);
  return data;
};

export const fetchTeamData = async (payload) => {
  const data = await postAPICall(PERFORMANCE, true, payload);
  return data;
};

export const fetchCompetitions = async () => {
  const data = await getAPICall(GET_COMPETITIONS_ON_HOME, true);
  return data;
};

export const updateCompetitionActivity = async (payload) => {
  const data = await postAPICall(UPDATE_COMPETITION_ACTIVITY, true, payload);
  return data;
};

export const updateSortByOrderOfKpiApi = async (payload) => {
  const data = await putAPICall(UPDATE_SORT_ORDER, true, payload);
  return data;
};

export const fetchWeeklyTotals = async (payload) => {
  const data = await postAPICall(WEEKLY_TOTALS, true, payload);
  return data;
};

export const updateUserCelebrationDate = async (payload) => {
  const data = await postAPICall(UPDATE_USER_CELEBRATION_DATE, true, payload);
  return data;
};

export const clearAllNotifications = async () => {
  const data = await postAPICall(CLEAR_ALL_NOTIFICATIONS, true);
  return data;
};

export const getUserCelebrationDetails = async (payload) => {
  const data = await getAPICall(GET_USER_CELEBRATION_DATE, true, payload);
  return data;
};

export const fetchUserAchievements = async (payload) => {
  const data = await getAPICall(GET_USER_STREAK_DATA, true, payload);
  return data;
};

export const fetchUserNotifications = async () => {
  const data = await getAPICall(USER_NOTIFICATIONS, true);
  return data;
};

export const updateSoundEnabledConfig = async (payload) => {
  const { uclId, soundEnabled } = payload;
  const data = await postAPICall(`${USER_CONFIGS}/${uclId}`, true, {
    value: soundEnabled,
    name: "SOUND_ENABLED",
  });
  return data;
};

export const setSeenNotification = async (id) => {
  const data = await putAPICall(`${SEEN_NOTIFICATION}/${id}`, true);
  return data;
};

export const clearAllNotificationsForWinWireMessage = async (payload) => {
  const data = await postAPICall(CLEAR_NOTIFICATIONS_FOR_WINWIRE_MESSAGE, true, payload);
  return data;
};
